export default __webpack_public_path__ + "static/roots-1b5623242efd606c6bcba7d6142579dc.png";